"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75em 1.125em;\n\n  margin-bottom: 1.5em;\n\n  font-size: ", ";\n  font-weight: bold;\n  color: #fff;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  border-radius: 5rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n\n  ", "\n  background-color: var(--color-grey-dark-1);\n  box-shadow: var(--box-shadow-node);\n\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: calc(", " * ", ");\n  height: calc(", " * ", ");\n  border-radius: 0.375em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles");

var DEFAULT_SIZE = '30rem';

exports.initImageOptionViewShapeStyle = function (scale) {
  return styled_components_1.css(_templateObject(), DEFAULT_SIZE, Math.pow(scale, scale), DEFAULT_SIZE, Math.pow(scale, scale));
};

exports.StyledImageOptionDiv = styled_components_1.default.div(_templateObject2(), function (props) {
  return exports.initImageOptionViewShapeStyle(props.theme.scale);
}, function (_ref) {
  var imageUrl = _ref.imageUrl;
  return imageUrl && "url(\"".concat(imageUrl, "\")");
});
exports.StyledImageNameDiv = styled_components_1.default.div(_templateObject3(), function (props) {
  return props.theme.fontSize.medium + 'rem';
});
exports.StyledImageNameDiv.defaultProps = {
  theme: scenario_node_view_styles_1.DEFAULT_SCENARIO_NODE_THEME
};